import { motion } from "framer-motion";
import { Droplets, Eye, Gauge, Wind } from "lucide-react";

export function WindAtmosphereCard({ item, weather, convertTemp, tempSymbol }) {
  if (!weather) return null;

  return (
    <motion.div variants={item} className="col-span-1 md:col-span-2 row-span-2 glass rounded-3xl p-4 md:p-5" data-testid="wind-atmosphere-card">
      <h3 className="font-semibold mb-4 text-white/80 flex items-center gap-2">
        <Wind className="w-4 h-4 text-[#00f2ea]" />
        Wind & Atmosphere
      </h3>

      <div className="flex items-center justify-center mb-6">
        <div className="relative w-32 h-32">
          <div className="absolute inset-0 rounded-full border-2 border-white/10" />
          <div className="absolute inset-2 rounded-full border border-white/5" />
          <span className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1 text-xs font-bold text-white/60">N</span>
          <span className="absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-1 text-xs font-bold text-white/40">S</span>
          <span className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-1 text-xs font-bold text-white/40">W</span>
          <span className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-1 text-xs font-bold text-white/40">E</span>
          <div className="absolute inset-4 flex items-center justify-center" style={{ transform: `rotate(${weather.wind?.deg || 0}deg)` }}>
            <div className="w-1 h-12 bg-gradient-to-t from-[#00f2ea] to-[#7000ff] rounded-full relative">
              <div className="absolute -top-1 left-1/2 -translate-x-1/2 w-0 h-0 border-l-[6px] border-r-[6px] border-b-[10px] border-transparent border-b-[#7000ff]" />
            </div>
          </div>
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="w-8 h-8 rounded-full bg-white/5 flex items-center justify-center">
              <span className="text-xs font-bold">{Math.round(weather.wind?.speed || 0)}</span>
            </div>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-3 mb-4">
        <div className="glass-light rounded-xl p-3 text-center">
          <p className="text-xs text-white/50 uppercase mb-1">Speed</p>
          <p className="text-xl font-bold">{Math.round(weather.wind?.speed || 0)} <span className="text-sm font-normal">mph</span></p>
        </div>
        <div className="glass-light rounded-xl p-3 text-center">
          <p className="text-xs text-white/50 uppercase mb-1">Direction</p>
          <p className="text-xl font-bold">{weather.wind?.deg || 0}°</p>
        </div>
      </div>

      <div className="space-y-3">
        <div className="flex items-center justify-between py-2 border-t border-white/5">
          <div className="flex items-center gap-2"><Gauge className="w-4 h-4 text-[#ccff00]" /><span className="text-sm text-white/60">Pressure</span></div>
          <span className="font-mono font-bold">{weather.main.pressure} hPa</span>
        </div>
        <div className="flex items-center justify-between py-2 border-t border-white/5">
          <div className="flex items-center gap-2"><Eye className="w-4 h-4 text-[#a1a1aa]" /><span className="text-sm text-white/60">Visibility</span></div>
          <span className="font-mono font-bold">{Math.round((weather.visibility || 10000) / 1609)} mi</span>
        </div>
        <div className="flex items-center justify-between py-2 border-t border-white/5">
          <div className="flex items-center gap-2"><Droplets className="w-4 h-4 text-[#00f2ea]" /><span className="text-sm text-white/60">Dew Point</span></div>
          <span className="font-mono font-bold">{convertTemp(weather.main.temp - ((100 - weather.main.humidity) / 5))}{tempSymbol}</span>
        </div>
      </div>
    </motion.div>
  );
}

export default WindAtmosphereCard;